import React from "react";
import {formatValueAsDateAndTime} from "../../../../helpers/utils/DateUtils";
import {useSelector} from "react-redux";

const OrderPreview = () => {

    const previewData = useSelector((state: any) =>
        Object.values(
            state.tgxApi.queries
        ).filter((entry: any) => entry?.endpointName === 'getPreviewOrderList')
    );


    return (

        <>
            <div className={"table_data"}>
                <div>

                    <div className="table-responsive">
                        <table className="table table-hover table-striped w-full">
                            <thead>
                            <tr>
                                <th scope="col" className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap'}>Order No.</th>
                                <th scope="col" className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap'}>Order Date</th>
                                <th scope="col" className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap'}>Order Status</th>
                                <th scope="col" className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap'}>Product Type</th>
                                <th scope="col" className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap'}>Product Status</th>
                                <th scope="col" className={'bg-highlight-0 text-text-0 text-left whitespace-nowrap'}>State</th>
                            </tr>
                            </thead>

                            <tbody>

                            {/*// @ts-ignore*/}
                            {!previewData?.[0]?.data || (Object.keys(previewData?.[0]?.data).length !== 0 && previewData?.[0]?.data && previewData?.[0]?.data.length === 0) &&
                                <tr>
                                    <td colSpan={5}>There are no orders to display</td>
                                </tr>
                            }

                            {/*// @ts-ignore*/}
                            {Object.keys(previewData?.[0]?.data).length !== 0 && previewData?.[0]?.data && previewData?.[0]?.data.length > 0 && previewData?.[0]?.data.map((curOrder: any) => {
                                    return (
                                        <tr className={' even:bg-surface-7 hover:bg-surface-7 '}>
                                            <td><a
                                                href={curOrder.order !== null ? "/orders/" + curOrder.order.id : "/orders"}
                                                className="column-link active cursor text-highlight-4"
                                                target="_blank"> {curOrder.order !== null ? curOrder.order.customerOrderNumber : ""}</a>
                                            </td>
                                            <td>{curOrder.order !== null ? formatValueAsDateAndTime(curOrder.order.creationDate) : ""}</td>
                                            <td>{curOrder.order !== null ? curOrder.order.orderStatus : ""}</td>
                                            <td>{curOrder.product !== null ? curOrder.product.type : ""}</td>
                                            <td>{curOrder.product !== null ? curOrder.product.productStatus : ""}</td>
                                            <td>{curOrder.order !== null ? curOrder.order.state : ""}</td>
                                        </tr>
                                    )
                                })
                            }

                            </tbody>


                        </table>
                    </div>

                </div>


            </div>

        </>


    );

};

export default OrderPreview;
